<script setup lang="ts">
  import { Skeleton } from "@ui-kit";
</script>

<template>
  <div class="order-skeleton">
    <Skeleton width="100px" height="16px" />
    <Skeleton width="100%" height="26px" />
    <Skeleton width="90%" height="20px" />

    <Skeleton width="100%" height="40px" style="margin-top: 32px" />

    <Skeleton width="100%" height="20px" style="margin-top: 32px" />

    <Skeleton width="100%" height="152px" style="margin-top: 8px" />
    <Skeleton width="100%" height="152px" style="margin-top: 4px" />
    <Skeleton width="100%" height="152px" style="margin-top: 4px" />
  </div>
</template>

<style scoped>
  .order-skeleton {
    display: flex;
    flex-direction: column;
    flex: 1;
    gap: 16px;
    padding: 16px;
  }
</style>
